var _circle, _path, _path2, _circle2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTempIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5439 18.5871V11.25C15.5439 10.0074 16.5513 9 17.794 9C19.0366 9 20.044 10.0074 20.044 11.25V18.4949",
    stroke: "#3F3F3F",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.837 18.0002C14.1019 18.7828 13 20.388 13 22.2663C13 24.8808 15.1461 27.0003 17.7935 27.0003C20.4409 27.0003 22.5871 24.8808 22.5871 22.2663C22.5871 20.388 21.511 18.5871 19.7501 17.9023",
    stroke: "#3F3F3F",
    strokeWidth: 1.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.7939,
    cy: 22.2065,
    r: 3.03265,
    fill: "#3F3F3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7939 13.1084V19.7607",
    stroke: "#3F3F3F",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempIcon);
export default __webpack_public_path__ + "static/media/tempIcon.f325395f1f3c53011001158047fe6b42.svg";
export { ForwardRef as ReactComponent };